import { FC, ReactElement, useEffect } from 'react';
import { Modals } from '../exports/Enums';
import useUrlParams from '../../../hooks/utility/useUrlParams';
import useModalRouter from '../common/hooks/useModalRouter';
import { OnlineShopWebViewMessageTypes } from '../../../services/exports/Constants';
import useRouter from '../../../hooks/navigation/useRouter';

interface Props {
  children: ReactElement;
}

const MODALS_WITH_DEFAULT_PRESENTATION: Readonly<Modals[]> = [Modals.Login];

const IonProvider: FC<Props> = ({ children }): ReactElement => {
  const params = useUrlParams();
  const { open_modal } = params;
  const { openModal } = useModalRouter();
  const { navigate } = useRouter();

  useEffect(() => {
    document.addEventListener('message', resolveWebViewMessage);

    return () => document.removeEventListener('message', resolveWebViewMessage);
  }, []);

  const resolveWebViewMessage = (message: any): void => {
    if (message?.data?.type === OnlineShopWebViewMessageTypes.OpenModal) {
      openModal({
        id: message.data.payload.open_modal,
        presentation: MODALS_WITH_DEFAULT_PRESENTATION.includes(message.data.payload.open_modal) ? undefined : null,
        props: message.data.payload,
        onDidPresent,
      });

      return;
    }

    if (message?.data?.type === OnlineShopWebViewMessageTypes.Navigate) {
      Promise.try(() =>
        navigate({
          mobile: {
            path: message.data.payload.navigate,
            payload: message.data.payload,
          },
        }),
      ).then(onDidPresent);

      return;
    }
  };

  const onDidPresent = (): void => {
    setTimeout(() => {
      window.history.replaceState({}, document.title, window.location.pathname);
    }, 1000);
  };

  const resolveModal = (): void => {
    switch (open_modal) {
      case Modals.AddCreditCard:
        return openModal({ id: Modals.AddCreditCard, onDidPresent });
      case Modals.OrderTracker:
        return openModal({
          id: Modals.OrderTracker,
          presentation: null,
          props: params,
          onDidPresent,
        });
      case Modals.Login:
        return openModal({
          id: Modals.Login,
          props: params,
          onDidPresent,
        });
      default:
        return;
    }
  };

  useEffect(() => {
    resolveModal();
  }, []);

  return children;
};

export default IonProvider;
